import React from 'react';
import { formatNumbers } from 'utilities';
import { TableContainerProps } from './TableContainer.props';

const TableContainer = (props: TableContainerProps) => {
  const { number, multiplier = 1, prepend = '', append = '', decimalsToDisplay = 0 } = props;
  const getDisplay = () => {
    const format = {
      minimumFractionDigits: decimalsToDisplay,
      maximumFractionDigits: decimalsToDisplay,
    };
    return formatNumbers({
      value: number * multiplier,
      format,
      prefix: prepend,
      suffix: append,
      allowNegativeValue: null,
      currencyCode: null,
      blankIfNull: null,
      staticCurrency: null,
      currency: null,
    });
  };
  return <span>{getDisplay()}</span>;
};

export default TableContainer;
